import { Select } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { Templates } from '../../utilities/Templates'
import { changeTemplate } from '../../redux/slices/templateSlice'
import CreateTemplate from './CreateTemplate'
import { useEffect } from 'react'

const CMSTemplate = ({ page, slug }) => {
    const template = useSelector((state) => state.template.template)
    const dispatch = useDispatch()

    const editType = async () => { await dispatch(changeTemplate(page?.pageType || 0)) }
    useEffect(() => { editType() }, [dispatch])

    return (
        <div>
            <div className='w-100 mt-4 mb-5 d-flex justify-content-start'>
                <Select
                    className='page-select'
                    style={{ width: '30%' }}
                    options={Templates}
                    value={template !== 0 ? template : "Seçim Tipi Seçiniz"}
                    onChange={(e) => dispatch(changeTemplate(e))}
                />
            </div>
            <div>
                {template !== 0 ? <CreateTemplate page={page} slug={slug} /> : null}
            </div>
        </div>
    )
}

export default CMSTemplate